/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as cameraV1 from "./keyapis_vc_camera_v1.pb"

/**
 * Сервис управления компаниями
 */

/**
 * Сервис управления компаниями
 */
export class CompanyServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод генерации имперсонационной ссылки для владельца компании.
   * Возвращает одноразовую ссылку для имперсонации в сервисе inkey-front.
   * Сценарий работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=1013775798.
   * Метод доступен для: service, bti, admin
   */
  PostCompanyImpersonation = (req: PostCompanyImpersonationRequestDto, init?: RequestInit): Promise<PostCompanyImpersonationResponseDto> => {
    return fm.request<PostCompanyImpersonationRequestDto, PostCompanyImpersonationResponseDto>(`${this.host}/vc/api/v1/company/${encodeURIComponent(req.companyId)}/impersonation`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос генерации имперсонационной ссылки для компании
 */
export type PostCompanyImpersonationRequestDto = {
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  companyId: number
}
/**
 * Ответ на запрос генерации имперсонационной ссылки для компании
 */
export type PostCompanyImpersonationResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Имперсонационная ссылка
   */
  readonly data: PostCompanyImpersonationResponseCompanyImpersonationDto
  /**
   * Ошибка
   */
  readonly error: PostCompanyImpersonationResponseErrorDto
}>
/**
 * Имперсонационная ссылка
 */
export type PostCompanyImpersonationResponseCompanyImpersonationDto = {
  /**
   * Одноразовая ссылка для имперсонации
   */
  url: string
}
/**
 * Ошибка генерации имперсонационной ссылки для компании
 */
export type PostCompanyImpersonationResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
  /**
   * Владелец компании не найден
   */
  readonly ownerNotFound: PostCompanyImpersonationResponseErrorOwnerNotFoundRequestDto
  /**
   * Ошибка взаимодействия с сервисом User
   */
  readonly userServiceError: PostCompanyImpersonationResponseErrorUserServiceErrorRequestDto
  /**
   * Ошибка взаимодействия с сервисом vcfront
   */
  readonly vcfrontServiceError: PostCompanyImpersonationResponseErrorVcfrontServiceErrorRequestDto
}>
/**
 * Ошибка генерации имперсонационной ссылки для компании
 */
export type PostCompanyImpersonationResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
  /**
   * Владелец компании не найден
   */
  readonly ownerNotFound: PostCompanyImpersonationResponseErrorOwnerNotFoundDto
  /**
   * Ошибка взаимодействия с сервисом User
   */
  readonly userServiceError: PostCompanyImpersonationResponseErrorUserServiceErrorDto
  /**
   * Ошибка взаимодействия с сервисом vcfront
   */
  readonly vcfrontServiceError: PostCompanyImpersonationResponseErrorVcfrontServiceErrorDto
}>
/**
 * Владелец компании не найден
 */
export type PostCompanyImpersonationResponseErrorOwnerNotFoundRequestDto = {
}
/**
 * Владелец компании не найден
 */
export type PostCompanyImpersonationResponseErrorOwnerNotFoundDto = {
}
/**
 * Ошибка взаимодействия с сервисом User
 */
export type PostCompanyImpersonationResponseErrorUserServiceErrorRequestDto = {
}
/**
 * Ошибка взаимодействия с сервисом User
 */
export type PostCompanyImpersonationResponseErrorUserServiceErrorDto = {
}
/**
 * Ошибка взаимодействия с сервисом vcfront
 */
export type PostCompanyImpersonationResponseErrorVcfrontServiceErrorRequestDto = {
}
/**
 * Ошибка взаимодействия с сервисом vcfront
 */
export type PostCompanyImpersonationResponseErrorVcfrontServiceErrorDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос генерации имперсонационной ссылки для компании
   */
  "PostCompanyImpersonationRequest": {
    "kind": "class",
    "text": "Запрос генерации имперсонационной ссылки для компании",
    "fields": {
      /**
       * Идентификатор компании.
       * # Диапазон: 1..2147483647
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос генерации имперсонационной ссылки для компании
   */
  "PostCompanyImpersonationResponse": {
    "kind": "class",
    "text": "Ответ на запрос генерации имперсонационной ссылки для компании",
    "fields": {
      /**
       * Имперсонационная ссылка
       */
      "data": {
        "type": "PostCompanyImpersonationResponse.CompanyImpersonation",
        "text": "Имперсонационная ссылка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostCompanyImpersonationResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Имперсонационная ссылка
   */
  "PostCompanyImpersonationResponse.CompanyImpersonation": {
    "kind": "class",
    "text": "Имперсонационная ссылка",
    "fields": {
      /**
       * Одноразовая ссылка для имперсонации
       */
      "url": {
        "type": "string",
        "text": "Одноразовая ссылка для имперсонации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка генерации имперсонационной ссылки для компании
   */
  "PostCompanyImpersonationResponse.Error": {
    "kind": "class",
    "text": "Ошибка генерации имперсонационной ссылки для компании",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Владелец компании не найден
       */
      "ownerNotFound": {
        "type": "PostCompanyImpersonationResponse.Error.OwnerNotFound",
        "text": "Владелец компании не найден",
      },
      /**
       * Ошибка взаимодействия с сервисом User
       */
      "userServiceError": {
        "type": "PostCompanyImpersonationResponse.Error.UserServiceError",
        "text": "Ошибка взаимодействия с сервисом User",
      },
      /**
       * Ошибка взаимодействия с сервисом vcfront
       */
      "vcfrontServiceError": {
        "type": "PostCompanyImpersonationResponse.Error.VcfrontServiceError",
        "text": "Ошибка взаимодействия с сервисом vcfront",
      },
    },
  },
  /**
   * Владелец компании не найден
   */
  "PostCompanyImpersonationResponse.Error.OwnerNotFound": {
    "kind": "class",
    "text": "Владелец компании не найден",
  },
  /**
   * Ошибка взаимодействия с сервисом User
   */
  "PostCompanyImpersonationResponse.Error.UserServiceError": {
    "kind": "class",
    "text": "Ошибка взаимодействия с сервисом User",
  },
  /**
   * Ошибка взаимодействия с сервисом vcfront
   */
  "PostCompanyImpersonationResponse.Error.VcfrontServiceError": {
    "kind": "class",
    "text": "Ошибка взаимодействия с сервисом vcfront",
  },
}